@if (data.asPage) {
  <vdms-hq-ui-dialog-page-wrapper [breadcrumbs]="breadcrumbs" [title]="pageTitle" (back)="requestClose()">
    <div content class="relative supplier-dialog-host">
      <ng-container [ngTemplateOutlet]="body" />
    </div>
    <vdms-hq-ui-button
      footer
      (click)="onSubmit()"
      [disabled]="supplierForm.invalid || !hasChanges"
      color="primary"
      [sharedE2eId]="'suppliers-dialog-submit'"
      >{{ 'common.global.save' | translate }}</vdms-hq-ui-button
    >
  </vdms-hq-ui-dialog-page-wrapper>
} @else {
  <vdms-hq-ui-dialog-wrapper>
    <h1 title>{{ dialogTitle | translate }}</h1>
    <div content class="relative supplier-dialog-host">
      <ng-container [ngTemplateOutlet]="body" />
    </div>
    <ng-container footer>
      <vdms-hq-ui-button (click)="cancel()" color="secondary" [sharedE2eId]="'suppliers-dialog-cancel'">{{
        'common.global.cancel' | translate
      }}</vdms-hq-ui-button>
      <vdms-hq-ui-button
        (click)="onSubmit()"
        [disabled]="supplierForm.invalid || !hasChanges"
        color="primary"
        [sharedE2eId]="'suppliers-dialog-submit'"
        >{{ 'common.global.save' | translate }}</vdms-hq-ui-button
      >
    </ng-container>
  </vdms-hq-ui-dialog-wrapper>
}

<ng-template #body>
  <form
    [formGroup]="supplierForm"
    class="fit-inputs supplier-dialog"
    [class.supplier-dialog--as-page]="data.asPage"
    [sharedE2eId]="'suppliers-dialog-form'"
  >
    <vdms-hq-ui-section-wrapper [sharedE2eId]="'suppliers-dialog-details'">
      <vdms-hq-ui-form-section
        [title]="data.asPage ? ('pages.suppliers.details' | translate) : ''"
        [titleSize]="'medium'"
        [icon]="data.asPage ? 'manage_accounts' : undefined"
        [divider]="false"
        layout="single"
      >
        <vdms-hq-ui-form-input-text
          [formControlName]="'name'"
          [label]="'pages.suppliers.columns.name' | translate"
          [sharedE2eId]="'suppliers-dialog-name'"
        />
        @if ((isCreating$ | async) === false) {
          <vdms-hq-selector
            [formControlName]="'facility_of_origin'"
            class="material-custom-form"
            label="common.global.facility_of_origin"
            [sharedE2eId]="'suppliers-dialog-facility'"
            [sourceType]="sourceType.FACILITY_OF_ORIGIN"
            [emptyMessage]="'No Facility found or no exact match'"
            [allowCreate]="(permissionService.verifyWithOwnedPermissions$([Permission.CREATE_FIELDS]) | async) === true"
            (create)="openCreateFacilityOfOrigin($event)"
          />
        } @else {
          <vdms-hq-ui-loader [text]="'Creating new facility_of_origin field'" />
        }
        <vdms-hq-ui-form-input-chips
          formControlName="emails"
          [label]="'pages.suppliers.columns.emails' | translate"
          [hint]="missingEmail ? ('pages.suppliers.missing_emails_hint' | translate) : undefined"
          [sharedE2eId]="'suppliers-dialog-emails'"
        />
      </vdms-hq-ui-form-section>
      @if ((quarantineService.canManageQuarantineConfigs$ | async) && data.edit) {
        <vdms-hq-ui-form-section [divider]="false" layout="single">
          <p class="supplier-dialog__hint">{{ 'pages.suppliers.quarantine_hint' | translate }}</p>
          <vdms-hq-ui-form-input-select
            [formControlName]="'quarantine'"
            [label]="'pages.suppliers.quarantine_select' | translate"
            [multiple]="true"
            [selectOptions]="quarantineSelectOptions"
            [loading]="(isLoading$ | async) === true"
            [enableSelectAll]="true"
            [enableDeselectAll]="true"
            [sharedE2eId]="'suppliers-dialog-quarantine'"
          />
        </vdms-hq-ui-form-section>
      }
      <vdms-hq-ui-form-section [divider]="false" [bottomMargin]="'25px'" [columnSizes]="['2fr', '1fr']">
        <vdms-hq-ui-form-input-toggle
          [formControlName]="'auto_approve_delivery_packs'"
          [withFooter]="false"
          class="material-custom-form"
          label="common.global.auto_approve"
          [sharedE2eId]="'suppliers-dialog-auto-approve'"
        />
        @if (data.supplier?.is_global) {
          <div class="is-global-readonly">
            <mat-icon class="is-global-icon">verified</mat-icon>
            <span>{{ 'common.suppliers.is_global' | translate }}</span>
          </div>
        } @else if (!data.edit && (superAdminAccessService.isSuperAdmin$ | async) === true) {
          <vdms-hq-ui-form-input-toggle
            [formControlName]="'is_global'"
            class="material-custom-form"
            [label]="'common.suppliers.is_global' | translate"
            [disabled]="data.edit"
          />
        }
      </vdms-hq-ui-form-section>
      @if ((superAdminAccessService.isSuperAdmin$ | async) === true) {
        <vdms-hq-ui-form-section [divider]="false" layout="single">
          <vdms-hq-ui-form-input-toggle
            [formControlName]="'notifies_librarian_group'"
            [withFooter]="false"
            class="material-custom-form"
            label="common.global.notifies_librarian_group"
            [sharedE2eId]="'suppliers-dialog-notifies-librarian'"
          />
        </vdms-hq-ui-form-section>
      }
    </vdms-hq-ui-section-wrapper>

    @if (data.asPage) {
      <div class="supplier-dialog__users" [sharedE2eId]="'suppliers-dialog-users'">
        <vdms-hq-ui-selectable-tiles
          [dataSource]="usersDataSource"
          [filters]="usersDataSource.filters"
          [config]="usersSelectableConfig"
          [selected]="supplierForm.controls.users.value"
          (selectedChangeEmit)="updateSelection($event)"
          (updateSelectedListEmit)="usersSelectableConfig.selectedList.data = $event"
          (updateConfigEmit)="usersSelectableConfig = $event"
          (emptyActionButtonClick)="createNewUser()"
        />
      </div>
    }
  </form>
</ng-template>
